(function () {
  if (window.location.pathname !== "/pages/andre-taki") return;

  var labels = {
    "01": "sec-1",
    "02": "sec-2",
    "03": "sec-3",
    "04": "sec-4",
    "05": "sec-5",
    "06": "sec-6",
    "07": "sec-7",
    "08": "sec-8",
    "09": "sec-9",
    10: "sec-10",
    11: "sec-10",
  };

  function chipId(element) {
    var number =
      element && element.querySelector
        ? element.querySelector(".rc__chip-num")
        : null;
    return number ? labels[(number.textContent || "").trim()] : null;
  }

  function normalize() {
    document.querySelectorAll(".rc__chipnav a").forEach(function (anchor) {
      var id = chipId(anchor);
      if (!id) return;

      var button = document.createElement("button");
      button.className = anchor.className;
      button.type = "button";
      button.innerHTML = anchor.innerHTML;
      button.setAttribute("data-target", id);
      if (id === "sec-10") {
        var anchorNumber = button.querySelector(".rc__chip-num");
        if (anchorNumber) anchorNumber.textContent = "10";
      }
      anchor.replaceWith(button);
    });

    document.querySelectorAll(".rc__chipnav button").forEach(function (button) {
      var id = button.getAttribute("data-target") || chipId(button);
      if (!id) return;
      button.type = "button";
      button.setAttribute("data-target", id);
      if (id === "sec-10") {
        var buttonNumber = button.querySelector(".rc__chip-num");
        if (buttonNumber) buttonNumber.textContent = "10";
      }
    });
  }

  function go(chip, event) {
    var id = chip.getAttribute("data-target") || chipId(chip);
    var target = id ? document.getElementById(id) : null;
    if (!target) return;

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    normalize();
    target.scrollIntoView({ behavior: "smooth", block: "start" });
    if (history && history.replaceState)
      history.replaceState(null, "", "#" + id);
  }

  document.addEventListener(
    "click",
    function (event) {
      var chip =
        event.target && event.target.closest
          ? event.target.closest(".rc__chipnav button, .rc__chipnav a")
          : null;
      if (chip) go(chip, event);
    },
    true,
  );

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", normalize);
  } else {
    normalize();
  }
  setTimeout(normalize, 50);
  setTimeout(normalize, 300);
  setTimeout(normalize, 1200);
  setTimeout(normalize, 3000);
})();
